import React from 'react';
import { rem } from 'polished';
import Loader from 'oxyrion-ui/lib/Loader';
import PropTypes from 'prop-types';
import Img from 'react-image';
import styled from 'styled-components';
import { __ } from '../../../../Utils';
import Documentations from '../../Components/Documentations';
import { catalogDescTranslate } from '../../CatalogUtils';
import placeholder from '../Gallery/placeholder-image.png';

const Wrapper = styled.div`
  min-height: ${rem(200)};
  padding: ${rem(10)};
  margin: ${rem(10)};
  box-shadow: 0 ${rem(3)} ${rem(5)} 0 rgba(0, 0, 0, 0.16);
  display: flex;
  background-image: linear-gradient(
    to bottom,
    #f0f0f0,
    #ffffff,
    #ffffff,
    #ffffff,
    #ffffff
  );
`;

const Name = styled.div`
  margin-bottom: ${rem(6)};
  font-size: ${rem(18)};
  font-weight: bold;
  color: #434245;
`;

const Description = styled.div`
  font-size: ${rem(14)};
  color: #434245;
  font-weight: 300;
  max-width: 280px;
  margin-bottom: 16px;
`;

const NameAndDescWrapper = styled.div`
  margin-top: ${rem(12)};
`;

const VariantsWrapper = styled.div`
  width: 100%;
  margin-top: ${rem(12)};
  margin-left: ${rem(12)};
`;

const Image = styled(Img)`
  height: ${rem(140)};
  max-width: ${rem(260)};
  z-index: 2;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${rem(250)};
`;

const NoVariantsMessage = styled.div`
  text-align: center;
  color: #949191;
`;

const VariantsHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const VariantsTitle = styled(Name)``;

const MainInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  transition: all 0.3s linear;
  justify-content: space-between;
`;

const BottomWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${rem(5)};
  margin-bottom: ${rem(5)};
  align-items: center;
  color: #70af00;
  cursor: pointer;
  text-decoration: underline;
`;

const DownloadAll = styled.div`
  text-align: end;
  margin-top: 16px;
  font-size: 14px;
  color: #70af00;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const baseURL = process.env.REACT_APP_DOMAIN_2;

class ProductDocumentationCard extends React.PureComponent {
  render() {
    const { data, onProductClick, title } = this.props;

    const titleImage = data.images && data.images[0] && data.images[0].fullPath;

    return (
      <Wrapper>
        <MainInfoWrapper>
          <NameAndDescWrapper>
            <Name>{data.name}</Name>
            <Description>
              {catalogDescTranslate(
                this.props.appLang,
                data.shortDescriptionTranslations,
                data.shortDescription,
              )}
            </Description>
          </NameAndDescWrapper>

          <ImageWrapper>
            <Image
              src={[`${baseURL}/images/370x0/${titleImage}`, placeholder]}
              loader={<Loader color="#70af00" />}
            />
          </ImageWrapper>
          <BottomWrapper onClick={() => onProductClick(data._id)}>
            {__('Detail produktu')}
          </BottomWrapper>
        </MainInfoWrapper>
        <VariantsWrapper>
          <VariantsHeaderWrapper>
            <VariantsTitle>{title}</VariantsTitle>
          </VariantsHeaderWrapper>
          {data.documentation && data.documentation.length > 0 ? (
            <Documentations
              data={data.documentation}
              history={this.props.history}
              downloadFile={id => this.props.downloadFile(id)}
            />
          ) : (
            <NoVariantsMessage>
              {__('Neobsahuje dokumentáciu')}
            </NoVariantsMessage>
          )}
          <DownloadAll
            onClick={() =>
              this.props.downloadFiles(data.documentation.map(d => d._id))
            }
          >
            {__('Stiahnúť všetko')}
          </DownloadAll>
        </VariantsWrapper>
      </Wrapper>
    );
  }
}

ProductDocumentationCard.propTypes = {
  onProductClick: PropTypes.func.isRequired,
  downloadFile: PropTypes.func.isRequired,
  downloadFiles: PropTypes.func.isRequired,
  data: PropTypes.shape({}).isRequired,
  firm: PropTypes.string,
  title: PropTypes.string,
  history: PropTypes.shape({}),
};

ProductDocumentationCard.defaultProps = {
  firm: 'SK',
  title: '',
  history: {},
};

export default ProductDocumentationCard;



// WEBPACK FOOTER //
// ./src/Containers/ProductCatalog/Components/ProductDocumentationCard/index.jsx